import { IRawStyle, ITheme, memoizeFunction } from "@fluentui/react";

import {
  commonMozFocusInnerStyles,
  getCommonActiveStyles,
  getCommonDisabledIsFocusVisibleStyles,
  getCommonIsFocusVisibleStyles,
  getStandardControlSemanticColorsWithTheme,
  StandardControlSemanticColors,
} from "./";
import {
  baseFabricFocusAfterSelector,
  baseFabricFocusSelector,
  commonHighContrastFocusedDisabledStyles,
} from "./commonStyles";
import { getInnerBorderStyles } from "./getInnerBorderStyles";

const redlineMenuButtonStateStyles = (
  theme: ITheme,
  standardControlSemanticColors: StandardControlSemanticColors,
  expanded?: boolean,
  disabled?: boolean
): IRawStyle => {
  if (expanded) {
    return {
      background: standardControlSemanticColors.expandedBackgroundColor,
      selectors: {
        ":focus": [
          !disabled && {
            outline: "0",
          },
          disabled && [
            {
              color: standardControlSemanticColors.textDisabledColor,
            },
            commonHighContrastFocusedDisabledStyles,
          ],
        ],
        [baseFabricFocusSelector]: disabled
          ? getCommonDisabledIsFocusVisibleStyles(theme)
          : getCommonIsFocusVisibleStyles(theme),
        [baseFabricFocusAfterSelector]: getInnerBorderStyles({
          color: standardControlSemanticColors.focusedBorderColor,
          width: 2,
        }),
      },
    };
  }
  return {
    selectors: {
      // Menu items automatically receive :focus on hover, but we still need :hover styles for
      //  cases when we move focus via keyboard (while keeping the mouse hover on a different element)
      ":hover": !disabled && {
        background: standardControlSemanticColors.hoverBackgroundColor,
      },
      ":focus": [
        !disabled && {
          outline: "0",
        },
        {
          background: standardControlSemanticColors.hoverBackgroundColor,
          borderColor: standardControlSemanticColors.focusedBorderColor,
          selectors: {
            ":hover": {
              borderColor: "transparent",
            },
          },
        },
        disabled && {
          color: standardControlSemanticColors.textDisabledColor,
        },
      ],
      [baseFabricFocusSelector]: disabled
        ? getCommonDisabledIsFocusVisibleStyles(theme)
        : getCommonIsFocusVisibleStyles(theme),
      [baseFabricFocusAfterSelector]: getInnerBorderStyles({
        color: standardControlSemanticColors.focusedBorderColor,
        width: 2,
      }),
      ":active": getCommonActiveStyles(theme),
      "::-moz-focus-inner": commonMozFocusInnerStyles,
    },
  };
};

export const getMenuButtonStateStyles = memoizeFunction(
  (theme: ITheme, expanded?: boolean, disabled?: boolean): IRawStyle => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    return redlineMenuButtonStateStyles(
      theme,
      standardControlSemanticColors,
      expanded,
      disabled
    );
  }
);
